import * as yup from 'yup';

import { ERRORS_TEXTS } from '../../../../../const/validation';

export const schema = yup.object({
  title: yup.string().required(ERRORS_TEXTS.required),
  author: yup.string().required(ERRORS_TEXTS.required),
  motto: yup.string().required(ERRORS_TEXTS.required),
  currency: yup.string().required(ERRORS_TEXTS.required),
  minSumma: yup.number().positive().required(ERRORS_TEXTS.positive),
  tariffId: yup
    .string()
    .matches(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/, ERRORS_TEXTS.formatGuid)
    .required(ERRORS_TEXTS.required),
  tariffName: yup.string().required(ERRORS_TEXTS.required),
  leverage: yup.number().min(0, ERRORS_TEXTS.positive).required(ERRORS_TEXTS.required),
});
